import api from './api';

export const listAdminPosts = () =>
  api.get('/admin/community/posts').then(r => r.data.posts);

export const getAdminPostDetail = (id) =>
  api.get(`/admin/community/posts/${id}`).then(r => r.data);

export const setPostHidden = (id, hidden, reason) =>
  api.put(`/admin/community/posts/${id}`, { hidden, reason }).then(r => r.data.post);

export const setCommentHidden = (id, hidden, reason) =>
  api.put(`/admin/community/comments/${id}`, { hidden, reason }).then(r => r.data.comment);

export const deletePost = (id) =>
  api.delete(`/admin/community/posts/${id}`);

export const deleteComment = (id) =>
  api.delete(`/admin/community/comments/${id}`);
